import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import { ListDivider } from 'rmwc/List';
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';

import SerializeForm from 'form-serialize'

import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons,
} from 'rmwc/Card';


import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';

import StatusMessage from '../../util/StatusMessage'
import SearchComponent from '../SearchComponent';

class FCRegsSubReviewList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchStatus: false,
      status: '',
      errorMsg: '',
      message: '',
      open: false,
      page: 1,
      selectedReg: {
        fullCertId: '',
        submissionStart:'',
        submissionEnd:''
      },
      data: {
        fcSubmissionList:[],
        message:''
      },
      searchData: {
        searchTerm: '',
        criteria: ''
      }
    };
    
    this.handleuploadClick = this.handleuploadClick.bind(this)
  }


  componentDidMount() {
   this.fetchRegData(this.state.page)       
  }

  fetchRegData(pageNo){
     let data = Object.assign({}, this.state.data)

    api.fetchSubReviewerRegList(this.props.user.accessToken, 'FC', pageNo).then((result) => {
          const { status, errors} = result
          if (status === 'error') {
            this.setState({ errorMsg: 'Error in Fetching Detail' })  
          }
          if (status === 'success') {
            data.fcSubmissionList = result.data
            this.setState({data:data, searchStatus: false, page: pageNo})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details' })
        })

  }

  handleSearch = (searchTerm, criteria, pageNo) => {
    let certType = 'FC'
    let search = `reviewer/search_by_criteria`
    let data = Object.assign({}, this.state.data)
    let searchData = Object.assign({}, this.state.searchData)
    searchData.searchTerm = searchTerm
    searchData.criteria = criteria
    this.setState({searchData: searchData})

    let values = {
      'certType': certType,
      'searchTerm': searchTerm,
      'criteria': criteria,
      'pageNo': pageNo
    }
    api.reviewerSearch(this.props.user.accessToken, search, values)
    .then((result) => {
      if (result.status === 'success'){
        data.fcSubmissionList = result.data
        this.setState({data:data, searchStatus: true, page: pageNo})
      }
    })
  }

  handleFetch = (e) => {
    e.preventDefault()
    if (this.state.searchStatus === false) {
      this.fetchRegData(this.state.page)
    }
    else {
      this.handleSearch(this.state.searchData.searchTerm, this.state.searchData.criteria, parseInt(this.state.page))
    }
  }

  handleClear = (e) => {
    e.preventDefault()
    let searchData = Object.assign({}, this.state.searchData)
    searchData.searchTerm = ''
    searchData.criteria = ''
    this.setState({searchData: searchData})
    this.fetchRegData(1)
  }

  handleCycleChange = (e, selectedRegistration) => {
    e.preventDefault()
    let selectedReg = Object.assign({}, this.state.selectedReg)
    selectedReg.fullCertId = selectedRegistration.fullCertId
    selectedReg.submissionStart = selectedRegistration.submissionStart
    selectedReg.submissionEnd = selectedRegistration.submissionEnd
    this.setState({selectedReg: selectedReg, open: true, errorMsg:''})
  }

   handleSubmiCycleChange = (e) => {
    e.preventDefault()
    const selectedReg = Object.assign({}, this.state.selectedReg);
    let apiInput = {
      'cert_type': 'FC',
      'cert_id': selectedReg.fullCertId,
      'submission_start': selectedReg.submissionStart,
      'submission_end': selectedReg.submissionEnd
    }

      
    api.saveSubmissionCycleDates(this.props.user.accessToken,apiInput)
    .then((result) => {
      if(result.status === 'success'){
        this.setState({ errorMsg: result.message })
        if (this.state.searchData.searchTerm !== '') {
          this.handleSearch(this.state.searchData.searchTerm, this.state.searchData.criteria, parseInt(this.state.page))
        }
        else {
          this.fetchRegData(this.state.page)
        }
      }
      else{
        this.setState({ errorMsg: result.message }) 
        
      }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })


  }

  onInputChange = evt => {
    const selectedReg = Object.assign({}, this.state.selectedReg);
    selectedReg[evt.target.name] = evt.target.value;
    this.setState({selectedReg});

  };

  onPageTextChange = evt => {
    let page = Object.assign({}, this.state.page);
    page = evt.target.value;
    this.setState({page});

  };  

   handleuploadClick(evt, certParticipationId, fullCertId){
    evt.preventDefault()
    this.props.clickUpload(certParticipationId, fullCertId)
  };

  render() {
    const { open } = this.state;
    const {registeredUser} = this.state;
     let userListCompnent
     let handleCycleChange = this.handleCycleChange
     let openModal = this.openModal
     let handleuploadClick = this.handleuploadClick
     let handleFetch = this.handleFetch
     let handleSearch = this.handleSearch
     let handleClear = this.handleClear

     if(this.state.data.fcSubmissionList.length >0){
      userListCompnent = 
        ( <tbody>
            {this.state.data.fcSubmissionList.map(fcsubmission => (

              <tr>
                <td>{fcsubmission.userId}</td>
                <td>{fcsubmission.userName}</td>
                <td>{fcsubmission.firstName}</td>
                <td>{fcsubmission.lastName}</td>
                <td>{fcsubmission.email}</td>
                <td>{fcsubmission.phone}</td>
                <td>{fcsubmission.level}</td>
                <td>{fcsubmission.track}</td>
                <td>{fcsubmission.submissionStart}</td>
                <td>{fcsubmission.submissionEnd}</td>
                
                <td><Button dense onClick={((e) => handleCycleChange(e, fcsubmission))}>Action</Button></td>
                <td><Button onClick={((e) => handleuploadClick(e, fcsubmission.certPartId, fcsubmission.fullCertId))}>Upload</Button></td>
              </tr>
            ))}
          </tbody>  
        )

     }

     let cyclConfigModal=(
      <Dialog
        open={open}
         onClose={evt => this.setState({open: false})}
      >
        <DialogSurface>
        <DialogHeader>
          <DialogHeaderTitle>Submission Cycle Configuration</DialogHeaderTitle>
        </DialogHeader>
        <DialogBody>
          <TextField type="date"  className="datepicker-padding" label="Cycle Start" autoComplete="off" name="submissionStart" onChange={this.onInputChange} value={this.state.selectedReg.submissionStart}/>
          <br/>
          <br/>
          <TextField type="date"  className="datepicker-padding" label="Cycl End" autoComplete="off" name="submissionEnd" onChange={this.onInputChange} value={this.state.selectedReg.submissionEnd}/>
        </DialogBody>
        <DialogFooter>
            <StatusMessage error_msg = {this.state.errorMsg}/>
            <DialogFooterButton cancel>Close</DialogFooterButton>
            <DialogFooterButton onClick={((e) => this.handleSubmiCycleChange(e))}>Save</DialogFooterButton>
        </DialogFooter>
        </DialogSurface>
        <DialogBackdrop />  
      </Dialog>
    )

      return (
        <div>
            <div>Centa Certification - Submissions <Typography use= "caption"><b>(Please note that the list contains only Paid users)</b></Typography></div>
            <Grid>
              <GridCell span = "4">
                <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onPageTextChange} value={this.state.page}/>
                <Button  onClick={((e) => handleFetch(e))}>
                  Fetch
                </Button>
              </GridCell>
              <GridCell span="8">
              <SearchComponent onHandleSearch = {handleSearch}
                onHandleClear = {handleClear} />
              </GridCell>
            </Grid>

            <div>
              <table className="admin-table">
                <th>User Id</th>
                <th>User Name</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Level</th>
                <th>Track</th>
                <th>Cycle Start</th>
                <th>Cycle End</th>
                <th>Configure Cycle</th>
                <th>Upload</th>
                {userListCompnent}
                {cyclConfigModal}
              </table>
            </div>
        </div>
      )
    
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(FCRegsSubReviewList);


// WEBPACK FOOTER //
// ./src/views/reviewer/FCRegsSubReviewList.jsx